import { useStoreState } from "hooks";

function Currency(value: number | string | undefined) {
  const { storeInfo } = useStoreState((state) => state.store);
  const { config_currency_symbol } = storeInfo;
  return `${config_currency_symbol} ${value}`;
}

export default Currency;
